export default {
  path: 'plans',
  name: 'plans',
  component: () => import('../views/plans/Plans.vue'),
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'plans',
      linkText: 'Тарифы'
    }
  }
}